<template>
<div >
	<Navbar></Navbar>
	<div class="main-content">
		<Loader :show="loading"></Loader>
		<div class="container" v-if="!loading">
			
			<div class="card mt-2">
				<div class="card-body">

					<div class="page-header">
						<ol class="breadcrumb">
							<li class="breadcrumb-item">GENERAL</li>
							<li class="breadcrumb-item active">Vehículos</li>
						</ol>
						<div class="title">
							<h1>Vehículos</h1>
						</div>
						<div class="cta">
							
							<b-dropdown text="Acciones " right  variant="light" >
								<div @click="preloadCar()" class="dropdown-item" >Cargar nuevo vehículo</div>
								<router-link :to="`/cars/preload`" tag="a" class="dropdown-item" >Importar nuevos vehículos</router-link>
								<router-link :to="`/cars/batch-load/dua-transit`" tag="a" class="dropdown-item" >Cargar DUA Tránsito</router-link>
								<router-link :to="`/cars/batch-load/dua-import`" tag="a" class="dropdown-item" >Cargar DUA Importación</router-link>
								<router-link :to="`/cars/batch-load/stock`" tag="a" class="dropdown-item" >Cargar Stock</router-link>
								<router-link :to="`/cars/print-labels`" tag="a" class="dropdown-item" >Imprimir etiquetas</router-link>
								<div @click="exportData('stock')" class="dropdown-item" >Exportar listado </div>
								<div @click="exportData('all')" class="dropdown-item" >Exportar listado historico</div>
							</b-dropdown>

						</div>
					</div>

					<div class="filters-box">
						<div class="filter">
							<label>BUSCAR</label>
							<div class="form-control search-filter">
								<select class="" 
									v-model="filters.search_by" 
									>
									<option value="">Todos</option>
									<option value="chassis_number">Chasis</option>
									<option value="motor_number">Motor</option>
									<option value="lote">Lote</option>
									<option value="dua_transit">DUA Tránsito</option>
									<option value="dua_stock">DUA Stock</option>
									<option value="dua_dispatch">DUA Despacho</option>
									<option value="model">Modelo</option>
								</select> 
								<input 
									type="text" 
									class="" 
									placeholder="Buscar" 
									v-model="filters.search" 
									@keyup.enter="updateFilters($event)">
							</div>
						</div>
						<div class="filter">
							<label>Cliente</label>
							<select class="form-control" 
								v-model="filters.client_id" 
								@change="updateFilters($event)">
								<option value="">Todos</option>
								<option v-for="client in clients" :key="client.id" :value="client.id">{{client.name}}</option>
							</select>           
						</div>
						<div class="filter">
							<label>Depósito</label>
							<select class="form-control" 
								v-model="filters.deposit_id" 
								@change="updateFilters($event)">
								<option value="">Todos</option>
								<option value="1">Fiscal</option>
								<option value="2">Nacional</option>
							</select>           
						</div>
						
						<div class="filter">
							<label>Estado actual</label>
							<select class="form-control" 
								v-model="filters.status" 
								@change="updateFilters($event)">
								<option value="">Todos</option>
								<option value="PRE_ADMITTED">Pre ingresados</option>
								<div class="dropdown-divider"></div>
								<option value="IN_CUSTOMS_DEPOSIT"> Sin despachar</option>
								<option value="CUSTOMS_DISPATCHED">Despachados</option>
								<option value="WITHOUT_PRE_DELIVERY">Pendientes de pre entregar</option>
								<option value="PRE_DELIVERY_DONE">Pre entregas realizada</option>
								<option value="DELIVERY_REQUESTED">Entregas solicitadas</option>
								<option value="DELIVERY_SCHEDULED">Entregas programadas</option>
								<option value="DELIVERED">Entregados</option>
							</select>           
						</div>
						<!-- <div class="filter">
							<label>Estado</label>
							<select class="form-control" 
								v-model="filters.status" 
								@change="updateFilters($event)">
								<option value="">Todos</option>
								<option value="PRE_ADMITTED">Pre ingresados</option>
								*<option value="ADMITTED">En depósito temporal</option>
								<div class="dropdown-divider"></div>
								<option value="IN_CUSTOMS_DEPOSIT">Depósito fiscal</option>
								<option value="CUSTOMS_DISPATCH_PENDING"> - Sin despachar</option>
								<option value="CUSTOMS_DISPATCHED"> - Despachados</option>
								<div class="dropdown-divider"></div>
								<option value="IN_NATIONAL_DEPOSIT">Depósito nacional</option>
								<option value="WITHOUT_PRE_DELIVERY"> - Sin pre-entrega</option>
								<option value="PRE_DELIVERY_DONE"> - Pre entregas realizada</option>
								<div class="dropdown-divider"></div>
								*<option value="DELIVERY_REQUESTED">Entregas solicitadas</option>
								*<option value="DELIVERY_SCHEDULED">Entregas programadas</option>
								<option value="DELIVERED">Entregados</option>
							</select>           
						</div> -->
						<div >
							<b-dropdown right text="Acciones" ref="dropdown" class="" variant="secondary" >								
								<b-form-checkbox class="mx-2 my-3" v-model="filters.not_dispatched" value="true" @change="changeFilter()">Sin despachar</b-form-checkbox>	
								<b-form-checkbox class="mx-2 my-3" v-model="filters.dispatched" value="true" @change="changeFilter()">Despachados</b-form-checkbox>
								<b-form-checkbox class="mx-2 my-3" v-model="filters.not_predelivered" value="true" @change="changeFilter()">Sin Pre entregar</b-form-checkbox>
								<b-form-checkbox class="mx-2 my-3" v-model="filters.predelivered" value="true" @change="changeFilter()">Pre entregados</b-form-checkbox>
							</b-dropdown>       
						</div>
						
						<!-- <div class="btn btn-light " @click="exportData()">Exportar</div> -->
						
					</div>

					<table class="table table-clickeable">
						<tr class="table-head">
							<td>Chasis</td>
							<td>Vehículo</td>
							<td>Cliente</td>
							<td>Ubicación</td>
							<td>Estado</td>
						</tr>
						
						<router-link tag="tr" v-for="item of list" :key="item.id" :to="`/cars/${item.id}`" >
							<td>{{item.chassis_number}}</td>
							<td>
								<div class="tc">
									<span class="text-primary">{{item.brand.title}}</span>
									<span >{{item.model}}</span>
								</div>
							</td>
							<td>
								<div class="tc">
									<span class="text-primary">{{item.client.name}}</span>
									<span >{{item.client.business_name}}</span>
								</div>
							</td>
							<td>
								{{item.locationText}}
								<!-- <div class="tc" v-if="item.parkingSlot">
									<span class="text-primary">{{item.parkingSlot.typeText}}</span>
									<span >{{item.parkingSlot.code}}</span>
								</div>
								<div class="tc" v-else>
									<span class="" v-if="item.status=='PRE_ADMITTED'">{{item.deposit.title}}</span>
									<span class="text-primary" v-else>En deposito temporal</span>
								</div> -->
							</td>
							<td>
								<div class="tc">
									<span><div class="car-status-point" :class="item.status"></div>{{item.statusText}}</span>
									
									<span v-if="item.status=='PRE_ADMITTED' && item.admission_estimated_at" style="margin-left: 15px;">Ingreso estimado: {{item.admission_estimated_at | moment("DD-MM-YYYY")}}</span>
									<span v-if="item.status=='ADMITTED'" style="margin-left: 15px;">{{item.joined_at | moment("DD-MM-YYYY")}}</span>
									
									<span v-if="item.delivery_requested_at && !item.delivery_scheduled_at" style="margin-left: 15px;">
										Entrega solicitada por {{item.delivery_to_carrier}} {{item.delivery_requested_at | moment("DD-MM-YYYY")}}
									</span>
									<span v-if="item.status == 'DELIVERY_SCHEDULED' && item.delivery_scheduled_at" style="margin-left: 15px;">
										{{item.delivery_scheduled_at | moment("DD-MM-YYYY [a las] HH:mm")}}
									</span>
									<span v-if="item.status == 'DELIVERED' && item.delivered_at" style="margin-left: 15px;">
										{{item.delivered_at | moment("DD-MM-YYYY")}}
									</span>
									<span v-if="item.authorized" class="badge badge-success w-auto ml-3" >Autorizado</span>
									<!-- <span v-if="item.delivery_scheduled_at" style="margin-left: 15px;">{{item.delivery_scheduled_at | moment("DD-MM-YYYY")}}</span> -->
								</div>
							</td>
						</router-link>
						
					</table>


					<div class="alert alert-info text-center" v-if="list.length==0" >No se han encontrado vehículos</div>
					
					<vue-ads-pagination v-if="pagination"
						:total-items="pagination.total"
						:max-visible-pages="2"
						:items-per-page="pagination.length"
						:page="pagination.page-1"
						@page-change="pageChange"					
					></vue-ads-pagination>

				</div>
			</div>

			
		</div>
	</div>
	
	<CarPreview ref="carPreview"></CarPreview>

	<CarModalForm ref="carForm" @updated="load()" ></CarModalForm>

</div>
</template>

<script>
import gql from 'graphql-tag'
import listMixins from '@/mixins/listMixins'
import { buildExportUrl } from '@/lib/exportsUrl'

import Navbar from '@/components/Navbar'
import Loader from '@/components/Loader'
import CarPreview from '@/views/cars/CarPreview'
import CarModalForm from '@/views/cars/CarModalForm'

export default {
	name: 'cars',
	components:{
		Navbar,
		Loader,
		CarPreview,
		CarModalForm
	},
	mixins:[listMixins],
	data () {
		return {
			list:[],
			clients:[],
			loading: true,
		}
	},
	beforeMount(){
		this.filters = this.getValidUrlParams();
		console.log(this.filters);
		this.load();
	},
	methods:{
		exportData(stock){
			window.open(buildExportUrl('export-cars', { ...this.$route.query, stock }), '_blank');
		},
		load(){
			this.$apollo.query({
				query: gql`query (	$first: Int!, 
									$page: Int, 
									$search: String, 
									$search_by: String, 
									$status: String, 
									$client_id: ID, 
									$deposit_id: ID,
									$not_dispatched: String,
									$dispatched: String,
									$not_predelivered: String,
									$predelivered: String,
					) {
					cars(
							first: $first, 
							page: $page, 
							search: $search, 
							search_by: $search_by,
							status: $status, 
							client_id: $client_id, 
							deposit_id: $deposit_id,
							not_dispatched: $not_dispatched,
							dispatched: $dispatched,
							not_predelivered: $not_predelivered,
							predelivered: $predelivered,
						) {
						paginatorInfo {
							count
							currentPage
							total
						}
						data {
							id
							client{
								name
								business_name
							}
							brand{
								title
							}
							model
							parkingSlot{
								code
								deposit{
									title
								}
							}
							deposit{
								title
							}
							motor_number
							chassis_number
							admission_estimated_at
							delivery_requested_at
							delivery_to_carrier
							delivery_scheduled_at
							delivered_at
							joined_at
							authorized
							status
							statusText
							locationText			
						}
					}
					clientsAll{
						id
						name
					}
				}`,
				fetchPolicy: 'no-cache',
				variables: {
					page: this.pagination.page,
					first: this.pagination.length,
					search: this.filters.search,
					search_by: this.filters.search_by,
					status: this.filters.status,
					client_id: this.filters.client_id,
					deposit_id: this.filters.deposit_id,
					
					not_dispatched: this.filters.not_dispatched,
					dispatched: this.filters.dispatched,
					not_predelivered: this.filters.not_predelivered,
					predelivered: this.filters.predelivered,
				},
			})
			.then((data) => {
				this.list = data.data.cars.data;
				this.pagination.total = data.data.cars.paginatorInfo.total;
				this.clients = data.data.clientsAll;
				this.loading = false
			});
		},
		openPreview(id){
			this.$refs.carPreview.open(id)
		},
		preloadCar(){
			this.$refs.carForm.open()
		},
		changeFilter(){
			this.$nextTick(()=>{
				this.updateFilters()
			})
		}

	}
}


</script>

<style scoped lang="scss">

.search-filter{
	display: flex;

	select{
		margin-right: 10px;
	    border: none;
    	box-shadow: none;
	}
	input{	
    	border: none;
	    box-shadow: none;
	}

}
</style>
